import { Store } from 'vuex';
import { RootState } from '../types';
import { getRulesFromAccessToken, ability } from '../../lib/casl';
import { AuthGetterKeys, SET_ACCESS_TOKEN } from '../modules/auth';
import router, {
	getCaslDataFromRoutes,
	PERMISSION_DENIED_PATH,
} from '../../router';

export const abilityPlugin = (store: Store<RootState>) => {
	const accessToken = store.getters[`auth/${AuthGetterKeys.accessToken}`];

	if (accessToken) {
		const rules = getRulesFromAccessToken(accessToken);
		ability.update(rules);
	}

	return store.subscribe(mutation => {
		switch (mutation.type) {
			case `auth/${SET_ACCESS_TOKEN}`:
				{
					const accessToken = mutation.payload;

					if (!accessToken) {
						// reset ability
						ability.update([]);

						// not logged in. Page access will be handled by route guard
						// We should not do any extra rerouting here, otherwise might cause errors like:
						// Navigation cancelled from "/some/path" to "/permission-denied" with a new navigation.
						return;
					}

					const rules = getRulesFromAccessToken(accessToken);
					ability.update(rules);

					if (router.currentRoute.matched.length) {
						// check permission to route
						const { caslSubject, caslAction } = getCaslDataFromRoutes(
							router.currentRoute.matched,
						);
						if (caslSubject && caslAction) {
							const hasAccess = ability.can(caslAction, caslSubject);
							if (
								hasAccess &&
								router.currentRoute.path === PERMISSION_DENIED_PATH
							) {
								router.back();
							} else if (
								!hasAccess &&
								router.currentRoute.path !== PERMISSION_DENIED_PATH
							) {
								router.push({ path: PERMISSION_DENIED_PATH });
							}
						}
					} else {
						// seems router not fully initialized. No need to do anything
						// TODO: confirm the above statement
					}
				}
				break;
		}
	});
};
